<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import MerchandisingApi from "@/services/merchandising-api";

export default {
  page: {
    title: "Merchandising",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){
      
      for(var i=0; i<31; i++) {
        this.mform.planning.push(null);
      }

      var dt = new Date();

      this.mform.month = dt.getMonth() + 1;
      this.selectedMonth = this.mform.month;

      this.currentYear = dt.getFullYear();
      this.mform.year = this.currentYear;
      this.selectedYear = this.mform.year;

  },

  components: { Layout },
  data() {
    return {
 
      mform: {month: null, year: null, message: null, comments: null, onCallWeek: null, planning:[], promotions:[], offers:[]},

      daysOfMonth: [[ 1, 2, 3, 4, 5 ,6, 7 ], [8, 9, 10,11,12,13,14], [15,16,17,18,19,20,21], [22,23,24,25,26,27,28], [29,30,31, null, null, null, null]],

      selectedPlanning: null,
      animationText: null,

      currentYear: null,
      selectedMonth: null,
      selectedYear: null,

      staticPromotionId: 0,
      promotionBrand: null,
      promotionProduct: null,
      promotionOldPrice: null,
      promotionNewPrice: null,

      staticOfferId: 0,
      offerBrand: null,
      offerProduct: null,
      offerPrice: null,  

      isSendingForm:false
    };
  },
  methods: {

    addAnimation() {
      this.mform.planning[this.selectedPlanning-1] = this.animationText; 
      this.animationText=null;
    },

    removeAnimation() {
      this.mform.planning[this.selectedPlanning-1] = null;
      this.selectedPlanning = null;
    },

    addToPromotions() {

      if (!this.promotionBrand || !this.promotionProduct || !this.promotionNewPrice) {
        return;
      }

      this.mform.promotions.push({id: this.staticPromotionId++,brand: this.promotionBrand, product:this.promotionProduct, oldPrice:this.promotionOldPrice, newPrice:this.promotionNewPrice});

      this.promotionBrand = null;
      this.promotionProduct = null;
      this.promotionOldPrice = null;
      this.promotionNewPrice = null;
     
    },

    removeFromPromotions(promotionId) {
        
        for (var i=0; i < this.mform.promotions.length; i++) {

          if (this.mform.promotions[i].id == promotionId) {
            this.mform.promotions.splice(i, 1);
            break;
          }
        }   
    },

    addToOffers() {

      if (!this.offerBrand || !this.offerProduct || !this.offerPrice) {
        return;
      }

      this.mform.offers.push({id: this.staticOfferId++,brand: this.offerBrand, product:this.offerProduct, price:this.offerPrice});

      this.offerBrand = null;
      this.offerProduct = null;
      this.offerPrice = null;
     
    },

    removeFromOffers(offerId) {
        
        for (var i=0; i < this.mform.offers.length; i++) {

          if (this.mform.offers[i].id == offerId) {
            this.mform.offers.splice(i, 1);
            break;
          }
        }   
    },

    isPlanning() {
      for(var i=0; i < this.mform.planning.length; i++) {
        if (this.mform.planning[i] != null) return true;
      }

      return false;
    },

    sendForm() {
      this.isSendingForm=true
      if (!this.mform.promotions.length && !this.mform.offers.length && !this.mform.onCallWeek && !this.mform.message && !this.isPlanning()) {
        Swal.fire("Formulaire vide", "Veuillez remplir le formulaire avant de l'envoyer !", "warning")
        this.isSendingForm=false
        return;
      }

      Swal.fire({
        title: "Envoyer ?",
        html: "Le formulaire au format PDF sera <strong>envoyé par mail</strong> pour traitement !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, envoyer!"
      }).then(result => {
        if (result.value) {

          MerchandisingApi.sendForm(this.mform).then(
            (data)=>{

              if (data) {

                  Swal.fire("", "Veuillez <strong>vérifier</strong> que vous avez bien <strong>reçu par email une copie du formulaire</strong> au format PDF.", "success");

                  this.isSendingForm=false
                  this.month=null
                  this.year=null;
                  this.message=null
                  this.comments=null
                  this.onCallWeek=null;
                  this.planning=[];
                  this.promotions=[];
                  this.offers=[];
                  this.selectedPlanning= null;
                  this.animationText=null;
                  this.mform= {month: null, year: null, message: null, comments: null, onCallWeek: null, planning:[], promotions:[], offers:[]};

              } else  {

                Swal.fire("", "L'envoi du formulaire a échoué", "error");
              }
              
              /*Swal.fire("", "Vous pouvez garder une copie du formulaire envoyé.", "success");
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'Formulaire-Merchandising.pdf');
              document.body.appendChild(link);
              link.click();*/


              

            }
          )

        }else{
            this.isSendingForm=false
        }
      });

    },

  },
    

  watch : {

    selectedMonth : function() {
          this.mform.month = this.selectedMonth;
          this.mform.onCallWeek = null;
    },

    selectedYear : function() {
          this.mform.year = this.selectedYear;
          this.mform.onCallWeek = null;
    },
    
  }

  
};
</script>

<style>
.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>

<template>
  <Layout>

    <div class="row pb-4  pt-4">
      <div class="col-lg-12">
        <div class="card border border-primary">
          <div class="card-body">

            <div class="row">

              <div class="col-md-8 col-sm-12">
                  <h2 class="card-title " style="font-size:2em;">Formulaire de Merchandising</h2>
              </div>

               <div class="col-md-2 col-sm-12 pr-md-3 text-right">
                <div class="input-group input-group-sm"> 

                  <b-select v-model="selectedMonth" class="custom-select custom-select-sm">
                    <option value="1">Janvier</option>
                    <option value="2">Février</option>
                    <option value="3">Mars</option>
                    <option value="4">Avril</option>
                    <option value="5">Mai</option>
                    <option value="6">Juin</option>
                    <option value="7">Juillet</option>
                    <option value="8">Août</option>
                    <option value="9">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                  </b-select>
                  <div class="input-group-prepend">
                    <label class="input-group-text font-weight-bold">Mois</label>
                  </div>  
                </div>
              </div>

              <div class="col-md-2 col-sm-12 text-right">
                <div class="input-group input-group-sm"> 

                  <select v-model="selectedYear"  class="custom-select custom-select-sm">
                    <option selected :value="currentYear">{{currentYear}}</option>
                    <option :value="currentYear+1">{{currentYear+1}}</option>
                  </select>
                  <div class="input-group-append">
                    <label class="input-group-text font-weight-bold ">Année</label>
                  </div>  
                </div>
              </div>
            </div>

            <div class="row">
             <div class="col-md-8 col-sm-12 text-left">
               <p class="card-title-desc ">
                    Veuillez <strong>remplir le formulaire</strong> ci-dessous et cliquer sur le <strong>bouton Envoyer</strong> par la suite
                  </p>
             </div>
             
              <div class="col-md-4 col-sm-12 text-right">
                  <b-button @click="sendForm()" variant="success" class="w-100" :disabled="this.isSendingForm">
                      <b-spinner small :class="this.isSendingForm ? '' : 'd-none'"></b-spinner>
                      <i class="fa fa-paper-plane font-size-14 align-middle mr-2 ml-2"></i> <strong class="font-size-16">Envoyer le Formulaire</strong>
                  </b-button>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row  pt-4" style="border:">
      <div class="col-lg-12" :style="mform.promotions.length ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'"> 
        <div class="card">
          <div class="card-body">
            <h4 class="card-title" >Les Promotions du Mois</h4>
            
            <div class="row pt-4"> 
                <div class="col-sm-2 pr-3">
                    <b-form-group label="Marque" label-for="">
                        <b-form-input v-model="promotionBrand" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-4 pr-3">
                    <b-form-group label="Nom du Produit" label-for="">
                          <b-form-input v-model="promotionProduct" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-2 pr-3">
                    <b-form-group label="Ancien Prix" label-for="">
                        <b-form-input v-model="promotionOldPrice" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-2 pr-3">
                    <b-form-group label="Prix Remisé" label-for="">
                          <b-form-input v-model="promotionNewPrice" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-1">
                    <b-form-group class="text-center" label="Valider" label-for="">
                      <a @click="addToPromotions()" href="javascript:void(0);" v-if="mform.promotions.length < 8" class="action-icon font-size-20 text-info">
                        <i v-b-tooltip.hover title="Ajouter" class="fas fa-plus text-info mt-2"></i></a>
                    </b-form-group> 
                </div>
            </div> 
            
            <div v-for="data in mform.promotions" :key="data.id" class="row pt-2">
                
              <div class="col-sm-2 col-xs-12 pr-sm-3 text-center font-weight-bold">
                    <span>{{data.brand}}</span>
              </div>

                <div class="col-sm-4 col-xs-12 pr-sm-3 text-center font-weight-bold">
                    <span>{{data.product}}</span>
                </div>

                <div class="col-sm-2 col-xs-12 pr-sm-3 text-center font-weight-bold">
                   <span>{{data.oldPrice}}</span>
                </div>

                <div class="col-sm-2 col-xs-12 pr-sm-3 text-center font-weight-bold">
                    <span>{{data.newPrice}}</span>
                </div>

                <div class="col-sm-1 col-xs-12 text-center">
                    <a @click="removeFromPromotions(data.id)" href="javascript:void(0);" class="action-icon text-danger">
                      <i v-b-tooltip.hover title="Retirer" class="fas fa-trash-alt font-size-16 text-danger"></i>
                    </a>
                </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row  pt-4" style="border:">
      <div class="col-lg-12" :style="mform.offers.length ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title " >Les Offres du Mois</h4>
            
             <div class="row pt-4"> 
                <div class="col-sm-2 pr-3">
                    <b-form-group label="Marque" label-for="">
                          <b-form-input v-model="offerBrand" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-6 pr-3">
                    <b-form-group label="Nom du Produit" label-for="">
                          <b-form-input v-model="offerProduct" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-2 pr-3">
                    <b-form-group label="Prix TTC" label-for="">
                          <b-form-input v-model="offerPrice" class="form-control text-center font-size-16"/>
                    </b-form-group>
                </div>

                <div class="col-sm-1">
                    <b-form-group class="text-center" label="Valider" label-for="">
                      <a @click="addToOffers()" v-if="mform.offers.length < 4" href="javascript:void(0);" class="action-icon font-size-20 text-info">
                        <i v-b-tooltip.hover title="Ajouter" class="fas fa-plus text-info mt-2"></i></a>
                    </b-form-group> 
                </div>
            </div> 

            <div v-for="data in mform.offers" :key="data.id" class="row pt-2">
                
              <div class="col-sm-2 pr-sm-3 text-center font-weight-bold">
                    <span>{{data.brand}}</span>
              </div>

                <div class="col-sm-6 pr-sm-3 text-center font-weight-bold">
                    <span>{{data.product}}</span>
                </div>

                <div class="col-sm-2 pr-sm-3 text-center font-weight-bold">
                   <span>{{data.price}}</span>
                </div>

                <div class="col-sm-1 text-center">
                    <a @click="removeFromOffers(data.id)" href="javascript:void(0);" class="action-icon text-danger">
                      <i v-b-tooltip.hover title="Retirer" class="fas fa-trash-alt font-size-16 text-danger"></i>
                    </a>
                </div>

            </div>

          </div>
        </div>
      </div>
    </div>



    <div class="row  pt-4" style="border:">
      <div class="col-lg-12" :style="mform.onCallWeek ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'">
        <div class="card">
          <div class="card-body">

            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <h4 class="card-title " >Semaine de Garde</h4>
                    <span class="card-title-desc ">
                      Sélectionner <strong>la date de début</strong> de votre semaine de garde 
                    </span>
                </div>

                <div class="col-md-6 col-sm-12">
                    <b-form-datepicker v-model="mform.onCallWeek"
                      
                      :min="mform.year + '-' + mform.month + '-' + '01'"
                      :max="mform.year + '-' + mform.month + '-' + '31'"
                      locale="fr"
                      label-no-date-selected="Date Début"
                      dark
                    ></b-form-datepicker>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row  pt-4" style="border:">
      <div class="col-lg-12" :style=" mform.message ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'">
        <div class="card">
          <div class="card-body">

            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <h4 class="card-title">Messages Personnalisés</h4>
                    <span class="card-title-desc ">
                      Ajouter des messages personnalisés si vous le souhaitez 
                    </span>
                </div>

                <div class="col-md-6 col-sm-12">
                  <textarea
                    v-model="mform.message"
                    class="form-control"
                    :maxlength="255"
                    rows="2"
                    placeholder="Ajouter des messages personnalisés si vous le souhaitez"
                  />
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    

    <div class="row  pt-4" style="border:">
      <div class="col-lg-12" :style=" mform.comments ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'">
        <div class="card">
          <div class="card-body">

            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <h4 class="card-title">Commentaires au responsable Merchandising</h4>
                    <span class="card-title-desc ">
                      Des commentaire à envoyer <strong>au responsable de Merchandising</strong>
                    </span>
                </div>

                <div class="col-md-6 col-sm-12">
                  <textarea
                    v-model="mform.comments"
                    class="form-control"
                    :maxlength="255"
                    rows="2"
                    placeholder="Ajouter des commentaires au responsable de Merchandising"
                  />
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row  pb-4  pt-4" style="border:">
      <div class="col-lg-12" :style="isPlanning() ? 'border-left: #34c38f solid 3px;' : 'border-left: #a7aaaf solid 3px;'">
        <div class="card">
          <div class="card-body">

            <h4 class="card-title">Planning des Animations</h4>
                    
            <div class="row" :class="!selectedPlanning ? 'd-none' : ''">

              <div class="col-12 pt-4">
                <span class="font-size-14"><strong class="text-info">Ajouter une animation</strong> prévue pour le <strong class="text-info">{{selectedPlanning}} {{selectedPlanning == 1 ? 'er' : 'ème'}} jour </strong> du mois</span>
              </div>

              <div class="col-12">
                
                <div class="input-group input-group-sm pull-right " >
                  <b-form-input @keyup.native.enter="addAnimation()" v-model="animationText" class="form-control form-control-sm font-weight-bold font-size-16"  />
                    <div size="sm" class="input-group-append">
                        <b-button variant="info" @click="addAnimation()">
                          <i class="fas fa-plus font-size-14 align-middle mr-2 ml-2"></i> Ajouter l'Animation
                      </b-button>

                      <b-button variant="danger" @click="removeAnimation()" class="pl-2">
                        <i class="fas fa-times font-size-14 align-middle p-0 mr-2 ml-2"></i> Supprimer l'Animation
                    </b-button>
                    </div>
                </div>

              </div>

            </div>
             
            <div class="row pb-4">  
              <div class="col-12 pt-4">
                  <div class="table-responsive mb-0">

                    <table class="w-100">

                      <tbody>

                        <tr v-for="r in daysOfMonth.length" :key="r">

                            <td v-for="day in daysOfMonth[r-1]" :key="day" @click="selectedPlanning=day;" :class="selectedPlanning != null && selectedPlanning == day ? 'bg-light' : ''" class="border border-light text-right" style="vertical-align: top;">
                            
                                <div class="p-2 float-right" style="width:200px; height:50px;">
                                  <span :class="!day ? '' : 'font-weight-bold  font-size-14'">{{!day ? '' : day}}</span>
                                </div>

                                <div class="p-2">
                                                                     
                                    <span :class="mform.planning[day-1] ? 'badge-info' : 'badge-white'" class="font-size-13 badge ml-1"  > {{mform.planning[day-1]}} 
                                    </span>
                                    
                                </div>
                              
                          </td>

                        </tr>

                      </tbody>

                    </table>
                  </div>
                 
              </div>

            </div>

             
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>